// 经纪人模块

//新增经纪人
function addBroker(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bInitLinkUserInfo", strjson: JSON.stringify(data) },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? true : false);
      }
    });
  });
}

//获取经纪人
function getBrokers() {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: Cookies.get("userid-b"), pagename: "bGetLinkUserInfo" },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? str.msg : false);
      }
    });
  });
}

//生成推广码
function createPromo(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "save", userid: Cookies.get("userid-b"), pagename: "bInitLintUserCode", idxpath: "pages/index/index", strjson: JSON.stringify(data) },
      success: res => {
        let str = JSON.parse(res);
        resolve(str.status == "ok" ? str.msg : false);
      }
    });
  });
}

//获取经纪人的二维码列表
function brokerCode(id) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "edit", userid: id, pagename: "bGetLintUserCode" },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status == "ok" ? str.msg : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

//删除经纪人推广码
function deletePromoCode(id) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      dataType: "json",
      data: { action: "del", userid: Cookies.get("userid-b"), codeid: id, pagename: "bDelLintUserCode" },
      success: res => {
        if (res) {
          let str = JSON.parse(res);
          resolve(str.status == "ok" ? true : false);
        } else {
          resolve(false);
        }
      }
    });
  });
}

export default {
  addBroker,
  getBrokers,
  createPromo,
  brokerCode,
  deletePromoCode
};
